<template>
    <button :class="{ selected }" class="app-card" @click="$emit('click')">
        <h4>
            <slot name="title"/>
        </h4>
        <p v-if="$slots.default">
            <slot/>
        </p>
    </button>
</template>

<script>
export default {
    name: 'app-card',
    props: {
        selected: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.app-card
    background: $white
    display: inline-block
    border: 1px solid $light-border-color
    color: $text-dark-grey
    -webkit-appearance: none
    text-align: left
    margin: 0
    transition: all 0.15s ease-in
    padding: 20px 25px
    border-radius: 10px
    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.05)
    cursor: pointer

    &:hover, &:focus
        background: $lighter-grey
        border: 1px solid $medium-grey
        box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05)
        transform: translateY(-2px)

    &.selected
        border: 2px solid $medium-blue
        padding: 19px 24px
        color: $dark-blue

    h4
        font-size: 18px
        margin: 10px 0 0

    p
        font-size: 14px
        margin: 10px 0
</style>